import { render } from "./StatusCard.vue?vue&type=template&id=52cc60fd&scoped=true"
import script from "./StatusCard.vue?vue&type=script&lang=js"
export * from "./StatusCard.vue?vue&type=script&lang=js"

import "./StatusCard.vue?vue&type=style&index=0&id=52cc60fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cc60fd"]])

export default __exports__